import { __assign, __rest } from "tslib";
import React from 'react';
import { cn } from '@bem-react/classname';
import { DividerLine } from './Line/Divider-Line';
import './Divider.css';
export var cnDivider = cn('Divider');
/**
 * Компонент для отделения одной информации от другой.
 * @param {IDividerProps} props
 */
export var Divider = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 1 : _b, color = _a.color, innerRef = _a.innerRef, style = _a.style, className = _a.className, children = _a.children, _c = _a.as, Component = _c === void 0 ? 'div' : _c, props = __rest(_a, ["size", "color", "innerRef", "style", "className", "children", "as"]);
    return (React.createElement(Component, __assign({}, props, { ref: innerRef, className: cnDivider(null, [className]), style: style }),
        React.createElement(DividerLine, { size: size, color: color }),
        children,
        children && React.createElement(DividerLine, { size: size, color: color })));
};
Divider.displayName = cnDivider();
